// ============================================================================
// UKRAINIAN TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Роздуми та цікаві питання про віру

export const funQuestions = [
  {
    question: "Який акт любові Ісуса найбільше надихає вас у повсякденному житті?",
    emoji: "❤️",
    theme: "любов"
  },
  {
    question: "Якби ви могли розділити трапезу з біблійним персонажем, хто б це був і чому?",
    emoji: "🍞",
    theme: "зустріч"
  },
  {
    question: "Яка притча Ісуса говорить з вами найглибше і чому?",
    emoji: "🌱",
    theme: "навчання"
  },
  {
    question: "Як проявляється Божий мир у вашому житті?",
    emoji: "🕊️",
    theme: "мир"
  },
  {
    question: "Яке чудо Ісуса ви хотіли б побачити?",
    emoji: "✨",
    theme: "віра"
  },
  {
    question: "Якби вам потрібно було описати Божу любов одним словом, яке б це було?",
    emoji: "💝",
    theme: "божественна любов"
  },
  {
    question: "Який вірш з Біблії допоміг вам у важкий момент?",
    emoji: "📖",
    theme: "втіха"
  },
  {
    question: "Як ви можете бути світлом світу сьогодні?",
    emoji: "💡",
    theme: "свідчення"
  }
];

export default funQuestions;
